export class InspectionWorkflow {
  status: number;
  next?: number;
  previous?: number;
  button?: string;
  backButton?: string;
  prices?: boolean;
  confirmation?: boolean;
  report?: boolean;
  close?: boolean;
  manager?: boolean;
}
